module.exports = __webpack_public_path__ + "static/img/yytx33.923f9af.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx33.png
// module id = 900
// module chunks = 0